import { useContext, useMemo, useSyncExternalStore } from "react";

import { ROLES, normalizeRole } from "../auth/access";
import useChatUnread from "./useChatUnread";
import {
   getStaffChatUnreadTotal,
   getStaffChatWorkspaceState,
   subscribeStaffChatWorkspace,
} from "../stores/staffChatWorkspaceStore";
import { UserContext } from "../UserContext";

/**
 * Unread badge for Mesaje nav:
 * - students: existing chatUnreadStore boolean → count 1/0
 * - staff: sum of per-conversation unread from workspace store
 */
export default function useMessagesUnreadBadge() {
   const { user } = useContext(UserContext);
   const role = normalizeRole(user?.role);
   const isStaff = role === ROLES.ADMIN || role === ROLES.MANAGER;
   const isStudent = role === ROLES.USER;

   const workspace = useSyncExternalStore(
      subscribeStaffChatWorkspace,
      getStaffChatWorkspaceState,
      getStaffChatWorkspaceState,
   );

   const { hasUnread: studentHasUnread } = useChatUnread();

   return useMemo(() => {
      if (isStaff) {
         const count = getStaffChatUnreadTotal();
         return {
            canAccess: true,
            unreadCount: count,
            hasUnread: count > 0,
            workspaceOpen: workspace.isOpen,
         };
      }
      if (isStudent) {
         return {
            canAccess: true,
            unreadCount: studentHasUnread ? 1 : 0,
            hasUnread: studentHasUnread,
            workspaceOpen: workspace.isOpen,
         };
      }
      return {
         canAccess: false,
         unreadCount: 0,
         hasUnread: false,
         workspaceOpen: false,
      };
   }, [isStaff, isStudent, studentHasUnread, workspace]);
}
